import React from 'react';
import PT from 'prop-types';
import { Box, colors, Typography } from '@procore/core-react';
import styled from 'styled-components';
import { UnstyledLink } from '@/react/styles';
import MobileLogo from '@/react/components/ProcoreLogo/MobileLogo';

const HeaderContainer = styled(Box)`
  background-color: ${colors.white};
`;

const MenuHeader = ({ marketplaceBasePath, title }) => (
  <HeaderContainer display="flex" justifyContent="flex-start">
    <UnstyledLink href={marketplaceBasePath}>
      <Box display="inline-flex" gap="md" alignItems="center">
        <MobileLogo />
        <Typography intent="h1" weight="semibold">
          {title}
        </Typography>
      </Box>
    </UnstyledLink>
  </HeaderContainer>
);

MenuHeader.propTypes = {
  marketplaceBasePath: PT.string.isRequired,
  title: PT.string.isRequired,
};

export default MenuHeader;
